import styled from 'styled-components';
import { IconButton, Toolbar } from "@material-ui/core";
import { Link } from 'react-router-dom';

export const ToolbarMobile = styled(Toolbar)`
  width: 100%;
  justify-content: space-between;
`;

export const Logo = styled.img`
  height: 30px;
`;

export const StyledIconButton = styled(IconButton)`
  && {
    color: white;
  }
`;

export const StyledLink = styled(Link)`
  font-size: 12px;
  font-weight: bold;
  text-decoration: none;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.white};
  padding: ${({ theme }) => theme.spacing * 3}px;
`;
